module.exports = {
      id: "share-instagram-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#share-instagram",
      toString: function () {
        return this.url;
      }
    }